var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import SearchSmSvg from './search-sm.icon.svg';
export const SearchSmIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: SearchSmSvg }));
_react_refresh_temp_1 = SearchSmIcon;
$RefreshReg$(_react_refresh_temp_1, "SearchSmIcon");
